import { render } from "./Center.vue?vue&type=template&id=430e9063"
const script = {}

import exportComponent from "../../../../../../../../projects/loyalzilla_admin/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"src/icons/Center.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "430e9063"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('430e9063', __exports__)) {
    api.reload('430e9063', __exports__)
  }
  
  module.hot.accept("./Center.vue?vue&type=template&id=430e9063", () => {
    api.rerender('430e9063', render)
  })

}


export default __exports__